/**
 * Compact article list shared by the spike-feed "What was the coverage?"
 * expander and the chart's click-a-day coverage panel. Titles are slug-derived
 * for BQ-captured rows (GKG stores no headlines), so the domain rides along as
 * the trust signal; syndication multipliers mark wire stories.
 */
import { ExternalLink } from "lucide-react";
import type { SalienceArticle } from "../../lib/api";

export function ArticleList({ articles }: { articles: SalienceArticle[] }) {
  return (
    <ul className="space-y-1">
      {articles.map((a) => (
        <li key={a.url} className="flex items-baseline gap-1.5 text-[12px]">
          <a
            href={a.url}
            target="_blank"
            rel="noreferrer"
            className="group inline-flex min-w-0 items-baseline gap-1 text-terminal-ink hover:underline"
          >
            <span className="truncate">{a.title || a.domain}</span>
            <ExternalLink className="h-3 w-3 shrink-0 self-center opacity-50 group-hover:opacity-100" />
          </a>
          <span className="shrink-0 text-[10px] text-terminal-ink-muted">
            {a.domain}
            {(a.syndicationCount ?? 1) > 1 && ` · ×${a.syndicationCount} syndicated`}
          </span>
        </li>
      ))}
    </ul>
  );
}

export function ArticleListSkeleton({ rows = 3 }: { rows?: number }) {
  return (
    <div className="space-y-1">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="h-5 animate-pulse rounded bg-white/5" />
      ))}
    </div>
  );
}
